import { TrackingContext, type TrackingContextValue } from '@ps/web-shared-analytics';
import React, { useCallback, useState } from 'react';
import { useInView } from 'react-intersection-observer';

import Tracker from './Tracker';

const VisibilityTracker: React.FC<
  React.PropsWithChildren<{ name: string; trackingContext: TrackingContextValue }>
> = ({ name, trackingContext, children }) => {
  const [seen, setSeen] = useState(false);

  const onVisibilityChange = useCallback((inView: boolean) => inView && setSeen(true), []);

  const { ref } = useInView({
    threshold: 0.1,
    rootMargin: '-50px 0px',
    skip: seen,
    onChange: onVisibilityChange
  });

  return (
    <div ref={ref}>
      {children}
      <TrackingContext.Provider value={trackingContext}>
        <Tracker seen={seen} name={name} />
      </TrackingContext.Provider>
    </div>
  );
};

export default VisibilityTracker;
